import * as React from 'react';
import { SafeAnchor } from '@stripe-internal/safe-links';
import { VIEW_CONFIG, getViewConfig } from './ViewConfig';
const DEFAULT_ELEMENT = 'div';
export function createElement(props) {
    const config = getViewConfig(props);
    let tag = config.tag || DEFAULT_ELEMENT;
    if (tag === 'a') {
        tag = SafeAnchor;
    }
    const rawProps = config.props;
    rawProps[VIEW_CONFIG] = undefined;
    const element = React.createElement(tag, config.props, config.props.children);
    rawProps[VIEW_CONFIG] = config;
    return element;
}

//# sourceMappingURL=createElement.js.map